import { useState } from 'react';
import { redeemGame as sendRedeemGame } from '../solana/transactions/redeemGame';

/**
 * Hook for handling redeem actions
 * Similar pattern to useTradeActions
 */
export function useRedeemAction() {
  const [isRedeeming, setIsRedeeming] = useState(false);
  const [redeemError, setRedeemError] = useState('');
  const [lastRedeemSignature, setLastRedeemSignature] = useState('');

  const redeemGame = async ({ gamePda, reserveVault, mint, tokensIn }) => {
    setIsRedeeming(true);
    setRedeemError('');
    setLastRedeemSignature('');

    try {
      const signature = await sendRedeemGame({
        gamePda,
        reserveVault,
        mint,
        tokensIn,
      });

      setLastRedeemSignature(signature);

      return signature;
    } catch (error) {
      const message = error?.message || 'Redeem transaction failed.';
      setLastRedeemSignature('');
      setRedeemError(message);
      throw error;
    } finally {
      setIsRedeeming(false);
    }
  };

  return {
    redeemGame,
    isRedeeming,
    redeemError,
    lastRedeemSignature,
  };
}
